import { render, staticRenderFns } from "./yingxiao.vue?vue&type=template&id=8d7f0f98"
import script from "./yingxiao.vue?vue&type=script&lang=js"
export * from "./yingxiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports